<div class="dialogContainer">
  <form #fpaSubmissionForm="ngForm">
    <div class="header">
      <h2>FPA Additional Information</h2>
    </div>
    @if (isBusy()) {
      <div class="busyIndicator">
        <div class="busyContents">
          <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
          <label class="busyLabel">Please Wait...</label>
        </div>
      </div>
    }
    @if (submissionData(); as submissionData) {
      <div class="content">
        <div class="inputRow">
          <span class="labelSpan">
            <label for="firstShipmentInput">Expected First Shipment</label>
          </span>
          <input id="firstShipmentInput" name="firstShipmentInput" class="inputField standardTextBox" maxlength="10"
            [ngClass]="{'inputError': firstShipmentInput.invalid}" required
            [(ngModel)]="submissionData.additionalData.expectedFirstShipment" #firstShipmentInput="ngModel"/>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="basisOfDesignSelection">Basis of Design</label>
          </span>
          <div class="selectWrapper" [ngClass]="{'inputError': basisOfDesignSelection.invalid}">
            <select id="basisOfDesignSelection" name="basisOfDesignSelection" class="inputField" required
              [(ngModel)]="submissionData.additionalData.basisOfDesign" #basisOfDesignSelection="ngModel">
              @for (basisOfDesign of fpaCompetitors(); track basisOfDesign) {
                <option [value]="basisOfDesign.id"
                  >{{ basisOfDesign.description }}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="competitorSelection">Competition</label>
          </span>
          <div class="selectWrapper" [ngClass]="{'inputError': competitorSelection.invalid}">
            <select id="competitorSelection" name="competitorSelection" class="inputField" required
              [(ngModel)]="submissionData.additionalData.competitorId" #competitorSelection="ngModel">
              @for (competitor of fpaCompetitors(); track competitor) {
                <option [value]="competitor.id">{{ competitor.description }}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="iecListedEqualInput">Listed as an equal</label>
          </span>
          <input id="iecListedEqualInput" name="iecListedEqualInput" type="checkbox" class="checkboxInput"
            [(ngModel)]="submissionData.additionalData.iecListedEqual"/>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="specifyingEngineerInput">Specifying Engineer</label>
          </span>
          <input id="specifyingEngineerInput" name="specifyingEngineerInput" class="inputField standardTextBox"
            maxlength="200" [ngClass]="{'inputError': specifyingEngineerInput.invalid}" required
            [(ngModel)]="submissionData.additionalData.specifyingEngineer" #specifyingEngineerInput="ngModel"/>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="engineerLocationInput">Engineer Location</label>
          </span>
          <input id="engineerLocationInput" name="engineerLocationInput" class="inputField standardTextBox"
            maxlength="200" [ngClass]="{'inputError': engineerLocationInput.invalid}" required
            [(ngModel)]="submissionData.additionalData.engineerLocation" #engineerLocationInput="ngModel"/>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="otherDetailsInput">Other Details</label>
          </span>
          <input id="otherDetailsInput" name="otherDetailsInput" class="inputField standardTextBox" maxlength="500"
            [(ngModel)]="submissionData.additionalData.otherDetails"/>
        </div>
        <div class="inputRow">
          <span class="labelSpan">
            <label for="bidDateInput">Project Bid Date</label>
          </span>
          <input [matDatepicker]="bidDatePicker" id="bidDateInput" name="bidDateInput"
            [value]="formatDisplayDate(submissionData.additionalData.projectBidDate)"
            (dateChange)="setProjectBidDate($event.value)"/>
          <mat-datepicker-toggle [for]="bidDatePicker"></mat-datepicker-toggle>
          <mat-datepicker id="bidDatePicker" name="bidDatePicker" #bidDatePicker></mat-datepicker>
        </div>
      </div>
    }
    @if (errorMessage()) {
      <div class="errorMessage">
        <pre>{{ errorMessage() }}</pre>
      </div>
    }
    <div mat-dialog-actions>
      <span class="spacer"></span>
      <span>
        <button matButton="elevated" (click)="cancel()">Cancel</button>
        <button matButton="elevated" [disabled]="isBusy() || !fpaSubmissionForm.valid" (click)="saveAndClose()">Save</button>
      </span>
    </div>
  </form>
</div>

